(function () {
  var root = document.getElementById("iphone18");
  if (!root) return;

  /* Тексты приходят из секции на языке страницы: pl / ru / uk / en.
     Значения полей формы (data-value) остаются польскими — по ним
     подбирается картинка и в таком же виде заявка приходит в магазин. */
  var I18N = {};
  try {
    var box = document.getElementById("iphone18-i18n");
    if (box) I18N = JSON.parse(box.textContent);
  } catch (e) {}

  var CHAPTERS = (I18N.chapters && I18N.chapters.length === 4) ? I18N.chapters : [
    { k: "APPTRADE · 9 września 2026", t: "iPhone 18 Pro", s: "Ciemna wiśnia. Pro i Pro Max. Przedsprzedaż od 12 września, sprzedaż od 18 września." },
    { k: "iPhone 18 Pro Max", t: "Światło na obudowie", s: "Ten sam obrót. Winna czerń łapie blask jak szkło." },
    { k: "Aparat", t: "Trzy obiektywy. Jedna belka.", s: "Główny moduł 48 MP. Światło ślizga się po obudowie koloru wina." },
    { k: "iPhone Duo", t: "Nowy format.", s: "Zewnętrzny 5,5″. W środku 7,8″ — obraz bez zagięcia." }
  ];
  var CHAPTER_AT = [0, 6.1, 13.7, 18.5];
  var FINISH = I18N.finish || { cherry: "Ciemna wiśnia", blue: "Błękit", black: "Czarny" };
  var COLOR_LABEL = I18N.colorLabel || {};
  var OPEN_TEXT = I18N.open || "Przedsprzedaż otwarta";

  /* Ceny rezerwacji (zł) приходят из секции (блок prices в iphone18-i18n) —
     одно место, чтобы менять цену без правки скрипта. Duo пока без цены. */
  var PRICES = I18N.prices || {};
  var PRICE_SOON = I18N.priceSoon || "cena wkrótce";
  function fmtPrice(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0") + "\u00a0zł";
  }
  function priceOf(model, storage) {
    var m = PRICES[model];
    return m && m[storage] ? m[storage] : 0;
  }
  /* Аксессуары к резерву: цены «от» в грошах из товаров магазина (snippet iphone18-addons-data). */
  var ADDONS = I18N.addons || {};
  var FROM = I18N.from || "od";
  function fmtGr(gr) {
    var zl = gr / 100;
    return (zl % 1 ? zl.toFixed(2).replace(".", ",") : String(zl)) + "\u00a0zł";
  }

  function label(value) {
    return COLOR_LABEL[value] || value;
  }

  var kicker = root.querySelector("[data-chapter-kicker]");
  var title = root.querySelector("[data-chapter-title]");
  var sub = root.querySelector("[data-chapter-sub]");
  var bar = root.querySelector("[data-reel-bar]");
  var desk = root.querySelector("[data-reel='desk']");
  var mob = root.querySelector("[data-reel='mob']");
  var chapter = 0;

  function activeVideo() {
    return window.matchMedia("(min-width: 768px)").matches ? desk : mob;
  }
  function syncPlay() {
    var on = activeVideo();
    var off = on === desk ? mob : desk;
    if (on) on.play().catch(function () {});
    if (off) off.pause();
  }
  function tick() {
    var node = activeVideo();
    var time = node && node.currentTime ? node.currentTime : 0;
    var duration = (node && node.duration) || 22.8;
    if (bar) bar.style.width = Math.min(100, (time / duration) * 100).toFixed(1) + "%";
    var next = 0;
    if (time >= CHAPTER_AT[3]) next = 3;
    else if (time >= CHAPTER_AT[2]) next = 2;
    else if (time >= CHAPTER_AT[1]) next = 1;
    if (next !== chapter) {
      chapter = next;
      var c = CHAPTERS[next];
      if (kicker) kicker.textContent = c.k;
      if (title) title.textContent = c.t;
      if (sub) sub.textContent = c.s;
    }
    requestAnimationFrame(tick);
  }
  if (desk && desk.querySelector("source")) {
    syncPlay();
    window.matchMedia("(min-width: 768px)").addEventListener("change", syncPlay);
    requestAnimationFrame(tick);
  }

  /* таймер ведёт к старту предзаказа Apple, а не к прошедшей презентации */
  var eventAt = Date.parse("2026-09-12T14:00:00+02:00");
  var count = root.querySelector("[data-countdown]");
  function pad(n) { return String(n).padStart(2, "0"); }
  function tickCount() {
    if (!count) return;
    var ms = eventAt - Date.now();
    if (ms <= 0) {
      count.textContent = OPEN_TEXT;
      return;
    }
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    count.querySelector("[data-d]").textContent = pad(d);
    count.querySelector("[data-h]").textContent = pad(h);
    count.querySelector("[data-m]").textContent = pad(m);
    count.querySelector("[data-s]").textContent = pad(s);
  }
  tickCount();
  setInterval(tickCount, 1000);

  var proShot = root.querySelector("[data-pro-shot]");
  var formShot = root.querySelector("[data-form-shot]");
  /* Раньше URL собирался подменой имени файла в ссылке cherry, из-за чего
     у всех картинок оставался ?v= версии cherry: при обновлении файла адрес
     не менялся и браузер отдавал старую копию из кэша. Теперь каждый URL
     приходит из Liquid со своей версией. */
  function asset(attr, name) {
    var v = root.getAttribute(attr);
    if (v) return v;
    var el = root.querySelector("[data-pro-shot]");
    return el ? el.getAttribute("src").replace("iphone18-cherry.png", name) : "";
  }
  var COLOR_IMG = {
    cherry: asset("data-img-cherry", "iphone18-cherry.png"),
    blue: asset("data-img-blue", "iphone18-blue.png"),
    black: asset("data-img-black", "iphone18-black.png"),
    silver: asset("data-img-silver", "iphone18-silver.png"),
    ultraNavy: asset("data-img-ultra-navy", "iphone18-duo-night.png"),
    ultraWhite: asset("data-img-ultra-white", "iphone18-duo-white.png")
  };

  /* Карточка Duo: два официальных цвета Apple, кадр меняется на месте. */
  var duoShot = root.querySelector("[data-duo-shot]");
  var DUO_IMG = { white: COLOR_IMG.ultraWhite, night: COLOR_IMG.ultraNavy };
  root.querySelectorAll("[data-duo-swatches] button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      root.querySelectorAll("[data-duo-swatches] button").forEach(function (b) { b.classList.remove("is-on"); });
      btn.classList.add("is-on");
      var c = btn.getAttribute("data-color");
      if (duoShot) duoShot.src = DUO_IMG[c] || DUO_IMG.white;
    });
  });

  root.querySelectorAll("[data-pro-swatches] button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      root.querySelectorAll("[data-pro-swatches] button").forEach(function (b) { b.classList.remove("is-on"); });
      btn.classList.add("is-on");
      var c = btn.getAttribute("data-color");
      if (proShot) proShot.src = COLOR_IMG[c] || COLOR_IMG.cherry;
    });
  });

  var orbit = root.querySelector("[data-orbit]");
  var finishName = root.querySelector("[data-finish-name]");
  if (orbit && finishName) {
    function finishAt(t) {
      if (t < 5.4) return FINISH.cherry;
      if (t < 10.8) return FINISH.blue;
      return FINISH.black;
    }
    function orbitTick() {
      finishName.textContent = finishAt(orbit.currentTime || 0);
      requestAnimationFrame(orbitTick);
    }
    requestAnimationFrame(orbitTick);
  }

  var modelInput = document.getElementById("iphone18-model");
  var colorInput = document.getElementById("iphone18-color");
  var storageInput = document.getElementById("iphone18-storage");
  var spec = root.querySelector("[data-form-spec]");
  var body = root.querySelector("[data-form-body]");
  var priceEl = root.querySelector("[data-form-price]");
  var priceInput = document.getElementById("iphone18-price");
  var submitPrice = root.querySelector("[data-submit-price]");
  var addonsBox = root.querySelector("[data-addons]");
  var addonsInput = document.getElementById("iphone18-addons-value");
  var reklamaInput = document.getElementById("iphone18-reklama");
  var addonsText = "";

  function isUltra() {
    return modelInput && /Duo/i.test(modelInput.value);
  }
  function isMax() {
    return modelInput && /Max/i.test(modelInput.value);
  }
  function syncColors() {
    var ultra = isUltra();
    root.querySelectorAll("[data-field='color'] button").forEach(function (btn) {
      var forUltra = btn.getAttribute("data-for") === "ultra";
      btn.hidden = ultra ? !forUltra : forUltra;
    });
    var visible = root.querySelector("[data-field='color'] button:not([hidden])");
    root.querySelectorAll("[data-field='color'] button").forEach(function (b) { b.classList.remove("is-on"); });
    if (visible) {
      visible.classList.add("is-on");
      colorInput.value = visible.getAttribute("data-value");
    }
    /* 2 ТБ Apple даёт и на Pro, и на Pro Max — ограничение снято. */
    updatePreview();
  }
  function updatePreview() {
    if (spec) spec.textContent = [modelInput.value, label(colorInput.value), storageInput.value].join(" · ");
    var price = priceOf(modelInput.value, storageInput.value);
    var priceText = price ? fmtPrice(price) : PRICE_SOON;
    var pricePlain = price ? priceText.replace(/\u00a0/g, " ") : "";
    if (priceEl) priceEl.textContent = priceText;
    if (priceInput) priceInput.value = pricePlain;
    if (submitPrice) submitPrice.textContent = price ? "· " + priceText : "";
    root.querySelectorAll("[data-price-for]").forEach(function (s) {
      var p = priceOf(modelInput.value, s.getAttribute("data-price-for"));
      s.textContent = p ? fmtPrice(p) : "";
    });
    var acc = ADDONS[modelInput.value];
    if (addonsBox) addonsBox.hidden = !acc;
    var picked = [];
    if (addonsBox) addonsBox.querySelectorAll("[data-addon]").forEach(function (cb) {
      var kind = cb.getAttribute("data-addon");
      var gr = acc && acc[kind];
      var label = cb.closest("label");
      if (label) label.hidden = !gr;
      var out = addonsBox.querySelector("[data-addon-price='" + kind + "']");
      if (out) out.textContent = gr ? (kind === "glass" ? "" : FROM + " ") + fmtGr(gr) : "";
      if (acc && gr && cb.checked) picked.push(cb.value);
    });
    addonsText = picked.join(", ");
    if (addonsInput) addonsInput.value = addonsText || "—";
    if (formShot) {
      if (isUltra()) {
        formShot.src = /Gwiezdna/i.test(colorInput.value) ? COLOR_IMG.ultraWhite : COLOR_IMG.ultraNavy;
      } else if (/Błękit/i.test(colorInput.value)) formShot.src = COLOR_IMG.blue;
      else if (/Srebrny/i.test(colorInput.value)) formShot.src = COLOR_IMG.silver;
      else if (/Czarny/i.test(colorInput.value)) formShot.src = COLOR_IMG.black;
      else formShot.src = COLOR_IMG.cherry;
    }
    if (body) {
      body.value =
        "Rezerwacja iPhone 18\n" +
        modelInput.value + " · " + colorInput.value + " · " + storageInput.value +
        (pricePlain ? " · " + pricePlain : "") +
        (addonsText ? " · + " + addonsText : "");
    }
  }

  root.querySelectorAll(".iphone18-pills[data-field]").forEach(function (group) {
    group.addEventListener("click", function (e) {
      var btn = e.target.closest("button");
      if (!btn || btn.hidden) return;
      group.querySelectorAll("button").forEach(function (b) { b.classList.remove("is-on"); });
      btn.classList.add("is-on");
      var field = group.getAttribute("data-field");
      var value = btn.getAttribute("data-value");
      if (field === "model") modelInput.value = value;
      if (field === "color") colorInput.value = value;
      if (field === "storage") storageInput.value = value;
      if (field === "model") syncColors();
      else updatePreview();
    });
  });

  root.querySelectorAll("[data-set-model]").forEach(function (a) {
    a.addEventListener("click", function () {
      var id = a.getAttribute("data-set-model");
      var map = { ultra: "iPhone Duo", pro: "iPhone 18 Pro", "pro-max": "iPhone 18 Pro Max" };
      var value = map[id] || "iPhone 18 Pro";
      modelInput.value = value;
      root.querySelectorAll("[data-field='model'] button").forEach(function (b) {
        b.classList.toggle("is-on", b.getAttribute("data-value") === value);
      });
      syncColors();
    });
  });
  /* Блок «Dostępne»: клик по строке подставляет модель, цвет и память
     в форму теми же кнопками, что нажимает человек, и форма скроллится сама. */
  root.querySelectorAll("[data-stock-pick]").forEach(function (a) {
    a.addEventListener("click", function () {
      function pick(field, value) {
        var group = root.querySelector(".iphone18-pills[data-field='" + field + "']");
        if (!group || !value) return;
        var btns = group.querySelectorAll("button");
        for (var i = 0; i < btns.length; i++) {
          if (btns[i].getAttribute("data-value") === value && !btns[i].hidden) { btns[i].click(); return; }
        }
      }
      pick("model", a.getAttribute("data-model"));
      pick("color", a.getAttribute("data-color"));
      pick("storage", a.getAttribute("data-storage"));
    });
  });
  syncColors();

  /* Переход из коллекции: /collections/iphone-18?model=duo — сразу
     подставляем нужную модель, чтобы человек не выбирал её заново. */
  try {
    var wanted = new URLSearchParams(window.location.search).get("model");
    var preset = { pro: "iPhone 18 Pro", "pro-max": "iPhone 18 Pro Max", duo: "iPhone Duo", ultra: "iPhone Duo" }[wanted];
    if (preset) {
      modelInput.value = preset;
      root.querySelectorAll("[data-field='model'] button").forEach(function (b) {
        b.classList.toggle("is-on", b.getAttribute("data-value") === preset);
      });
      syncColors();
    }
  } catch (e) {}

  /* После отправки формы Shopify возвращает на страницу с ?contact_posted=true —
     сразу показываем сообщение с инструкцией, а не верх лендинга. */
  if (/[?&]contact_posted=true/.test(window.location.search)) {
    var ok = document.getElementById("iphone18-form-ok");
    if (ok) ok.hidden = false;
    var target = ok || document.getElementById("iphone18-rezerwacja");
    if (target) setTimeout(function () { target.scrollIntoView({ block: "center" }); }, 300);
  }

  if (addonsBox) addonsBox.addEventListener("change", updatePreview);
  var form = document.getElementById("iphone18-form");
  if (form) {
    form.addEventListener("submit", function () {
      var phone = (form.querySelector('input[name="contact[phone]"]') || {}).value || "";
      var email = (form.querySelector('input[name="contact[email]"]') || {}).value || "";
      updatePreview();
      var source = window.atAttribution ? window.atAttribution() : "";
      if (reklamaInput) reklamaInput.value = source;
      if (window.atLead) window.atLead.save({
        model: modelInput.value,
        value: priceOf(modelInput.value, storageInput.value),
        test: /gannochka\.ss@gmail\.com/i.test(email) || /511\s*005\s*310/.test(phone)
      });
      var text =
        "APPTRADE — iPhone 18\n" +
        modelInput.value + " · " + colorInput.value + " · " + storageInput.value +
        (priceInput && priceInput.value ? " · " + priceInput.value : "") +
        (addonsText ? " · + " + addonsText : "") + "\n" +
        phone + "\n" + email;
      window.open("https://wa.me/48537922940?text=" + encodeURIComponent(text), "_blank", "noopener,noreferrer");
    });
  }
})();
